import { db } from "../services/firebase";

// import 'firebase/firestore';
// import { useAuthState } from 'react-firebase-hooks/auth';
import { RenderSidebarUser } from "../components/RenderUser";

import {
  useCollectionData,
  useDocumentData,
} from "react-firebase-hooks/firestore";

// import { getUserFromDb } from "../helpers/userManagement";

import { userTypes } from "../helpers/Types";

// import { Link } from 'react-router-dom';

// import UserProfile from "./UserProfile";

import "../css/board.css";

// import Renameable from './Renameable'

import {
  ModalDownloadMessagesButton,
  ModalDownloadMessages,
  ModalOpenaiCategorizeButton,
  ModalOpenaiCategorize,
  ModalOpenaiAnswerAIButton,
  ModalOpenaiAnswerAI,
  CreateWorkshopModalButton,
  ModalRemoveWorkshopButton,
  ModalRenameWorkshopButton,
  ModalCreateTeam,
  ModalAddUserToTeam,
  ModalCreateUser,
  ModalRemoveUser,
  ModalRemoveTeam,
  ModalRemoveWorkshop,
  ModalRenameWorkshop,
  ModalWoekshopsGooglePhotosLinkButton,
  ModalWorkshopGooglePhotos,
} from "./Modals";
import { useEffect, useState } from "react";
import { Button, Icon } from "react-materialize";

// import { removeUserFromTeam } from '../helpers/factory'

function SidebarStudent(props) {
  let [usr, usrLoading] = useDocumentData(
    db.collection("users").doc(props.uid)
  );

  // let usr = getUserFromDb(props.uid);
  if (usr && !usrLoading) {
    let schoolColor = "transparent";
    const matchingSchool = props.schools.find(
      (school) => school.id === usr.institutionId
    );
    if (matchingSchool) {
      schoolColor = matchingSchool.color;
    }

    return (
      <>
        <li
          key={usr.id}
          className="SidebarUser"
          style={{ borderRight: schoolColor + "solid 4px" }}
        >
          <RenderSidebarUser usr={usr} setOtherUserId={props.setOtherUserId} />
        </li>
      </>
    );
  }
  return null;
}

function SidebarSchool(props) {
  return (
    <>
      <div className="row">
        <div
          id={"schoolTab" + props.data.id}
          className="col s12 black-text"
          style={{ backgroundColor: props.data.color }}
        >
          <h6 className="schoolname">
            {props.data.name + ", " + props.data.location}
          </h6>
        </div>
      </div>
    </>
  );
}

function SidebarWorkshop(props) {
  const [schools, setSchools] = useState([]);
  const [schoolsLoading, setSchoolsLoading] = useState(true);

  useEffect(() => {
    const fetchSchools = async () => {
      const schoolPromises = props.workshop.institutions.map((institutionId) =>
        db.collection("institution").doc(institutionId).get()
      );
      const schoolDocs = await Promise.all(schoolPromises);
      const schoolData = schoolDocs.map((doc) => doc.data()).filter(data => data !== undefined);
      setSchools(schoolData);
      setSchoolsLoading(false);
    };

    fetchSchools();
  }, [props.workshop.institutions]);

  if (schoolsLoading || schools.length === 0) return null;

  const copyLink = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        alert("Link copied!");
      })
      .catch((err) => {
        console.error("Error copying link: ", err);
      });
  };

  return (
    <>
      <div id="SidebarWorkshop" className="row">
        <h5>
          {props.workshop.name}
          {props.user.type !== "student" && (
            <Button
              className="grey workshopLink"
              floating
              icon={<Icon>link</Icon>}
              node="button"
              waves="light"
              onClick={() =>
                copyLink(
                  `${window.location.origin}/login?workshop=${props.workshop.id}`
                )
              }
              tooltip="Click to copie the workshop link"
              tooltipOptions={{ position: "right" }}
            />
          )}
        </h5>
        {schools.map((school, index) => (
          <SidebarSchool key={index} data={school} />
        ))}

        <div className="row">
          <ul className="SidebarWorkshopStudents col s12">
            {props.workshop.students &&
              props.workshop.students.map((i) => (
                <SidebarStudent
                  key={i}
                  uid={i}
                  schools={schools}
                  setOtherUserId={props.setOtherUserId}
                />
              ))}
          </ul>
        </div>
      </div>
    </>
  );
}

function getWorkshopQueryForUser(usr) {
  let ws = db.collection("workshops");

  if (usr.type === userTypes().student) {
    return ws.where("students", "array-contains", usr.id);
  }
  if (usr.type === userTypes().instructor) {
    return ws.where("instructors", "array-contains", usr.id);
  }
  ws.orderBy("created", "desc");
  return ws;
}

function SelectWorkshop(props) {
  if (props.workshops.length === 0) return "";
  return (
    <>
      <div>
        <form>
          <label>Select Workshop</label>
          <select
            className="browser-default"
            onChange={(evt) =>
              setCurrentWorkshop(props.userId, evt.target.value)
            }
          >
            {props.workshops &&
              props.workshops.map((ws) => (
                <option key={ws.id} value={ws.id}>
                  {" "}
                  {ws.name}{" "}
                </option>
              ))}
          </select>
        </form>
      </div>
    </>
  );
}

function setCurrentWorkshop(userId, currentWorkshopId) {
  db.collection("users")
    .doc(userId)
    .set({ currentWorkshop: currentWorkshopId }, { merge: true });
  // let wscb = db.collection('users').doc(userId).data().workshopCurrentBoard ;

  // let [usr, usrLoading] = useDocumentData(db.collection('users').doc(userId));
  // if(usr && ! usrLoading){
  //     if(usr.workshopCurrentBoard && (typeof usr.workshopCurrentBoard === "object")){
  //         if(usr.workshopCurrentBoard[currentWorkshopId] != null){

  //         }
  //     }

  // }
}

export function SidebarWorkshopCollection(props) {
  const [workshops, workshopsLoading] = useCollectionData(
    getWorkshopQueryForUser(props.user)
  );

  // useEffect(() => initCollapsibles(".SidebarWorkshopCollection"));

  if (
    props.user.type === userTypes().student &&
    !workshopsLoading &&
    (!workshops || (workshops && workshops.length === 0))
  )
    return <h6>You are not part of any workshop!</h6>;

  let currentWorkshop = null;
  // console.log(workshops);
  if (workshops) {
    if (props.user.currentWorkshop) {
      for (let i = 0; i < workshops.length; i++) {
        if (props.user.currentWorkshop === workshops[i].id) {
          currentWorkshop = workshops[i];
        }
      }
    }
    if (!currentWorkshop && workshops && workshops.length > 0) {
      currentWorkshop = workshops[0];
      // console.log("settings users current workshop to ", currentWorkshop);
      setCurrentWorkshop(props.user.id, currentWorkshop.id);
      // db.collection('users').doc(props.user.id).set({currentWorkshop: currentWorkshop.id}, {merge: true});
    }
  }
  // console.log("currentWorkshop", currentWorkshop);
  return (
    <>
      {currentWorkshop && (
        <SidebarWorkshop
          workshop={currentWorkshop}
          user={props.user}
          setOtherUserId={props.setOtherUserId}
        />
      )}

      {currentWorkshop && props.user.type === userTypes().admin && (
        <ModalCreateUser currentWorkshop={currentWorkshop} />
      )}
      {currentWorkshop &&
        currentWorkshop.students &&
        props.user.type === userTypes().admin && (
          <ModalRemoveUser currentWorkshop={currentWorkshop} />
        )}

      {workshops && (
        <SelectWorkshop workshops={workshops} userId={props.user.id} />
      )}
      {props.user.type === userTypes().admin ? (
        <CreateWorkshopModalButton buttonLabel="Create workshop" />
      ) : (
        ""
      )}
      {props.user.type === userTypes().admin ? (
        <ModalRemoveWorkshopButton buttonLabel="Create workshop" />
      ) : (
        ""
      )}
      {props.user.type === userTypes().admin ? (
        <ModalRenameWorkshopButton />
      ) : (
        ""
      )}
      {props.user.type === userTypes().admin ? (
        <ModalWoekshopsGooglePhotosLinkButton />
      ) : (
        ""
      )}

      {/* { (props.user.type === userTypes().admin)? <CreateWorkshopModalButton buttonLabel="Edit current workshop" currentWorkshop={currentWorkshop}/>:"" } */}

      {currentWorkshop && props.user.type !== userTypes().student && (
        <ModalCreateTeam currentWorkshop={currentWorkshop} />
      )}
      {currentWorkshop && props.user.type !== userTypes().student && (
        <ModalRemoveTeam currentWorkshop={currentWorkshop} />
      )}
      {currentWorkshop && props.user.type !== userTypes().student && (
        <ModalAddUserToTeam currentWorkshop={currentWorkshop} />
      )}
      {currentWorkshop &&
        workshops &&
        props.user.type === userTypes().admin && (
          <ModalRemoveWorkshop
            currentWorkshop={currentWorkshop}
            workshops={workshops}
          />
        )}
      {currentWorkshop && props.user.type === userTypes().admin && (
        <ModalRenameWorkshop
          currentWorkshopId={currentWorkshop.id}
          currentWorkshopName={currentWorkshop.name}
        />
      )}
      {currentWorkshop && props.user.type === userTypes().admin && (
        <ModalWorkshopGooglePhotos currentWorkshop={currentWorkshop} />
      )}

      {currentWorkshop && props.user.type === userTypes().admin && (
        <>
          <ModalDownloadMessagesButton />
          <ModalDownloadMessages workshops={workshops} />
        </>
      )}

      {props.user.type === userTypes().admin && (
        <>
          <ModalOpenaiCategorizeButton type="tags" />
          <ModalOpenaiCategorize type="tags" />
        </>
      )}

      {props.user.type === userTypes().admin && (
        <>
          <ModalOpenaiCategorizeButton type="categories" />
          <ModalOpenaiCategorize type="categories" />
        </>
      )}

      {props.user.type === userTypes().admin && (
        <>
          <ModalOpenaiAnswerAIButton />
          <ModalOpenaiAnswerAI />
        </>
      )}
    </>
  );
}
